/**
 * The one rule for the Seller Collects fee picker (FP-3784 / FP-3804).
 *
 * Product (2026-10-30): the B-Stock fee is charged by credit card only. The
 * picker is card-only on a Seller Collects USD lot while Balance credit cards
 * are on. With them off it would fall back to the full picker, where ACH, Net
 * Terms and the ACH drawer are reachable, so the fee section opens nothing and
 * Balance emails the fee invoice. Non-USD keeps its wire-only picker.
 *
 * Every gate on this rule — the bid and Buy Now fee sections, the picker, and
 * the cards it lists — reads from here.
 */
export type SellerCollectsFeeAccess = {
  /** The listing currency is not USD: wire only, the standard picker. */
  isNonUsd: boolean
  /** The picker lists saved cards only and never opens the Add New drawer. */
  isFeeCardOnly: boolean
  /** The fee section may open the picker ("Change"). */
  canChangeCard: boolean
  /** A card may be added, or used: false where the account blocks cards. */
  canAddCard: boolean
}

export const getSellerCollectsFeeAccess = ({
  isSellerCollects,
  enableBalanceCreditCards,
  currency,
  isAccountCardBlocked,
}: {
  isSellerCollects: boolean
  enableBalanceCreditCards: boolean
  currency?: string
  isAccountCardBlocked: boolean
}): SellerCollectsFeeAccess => {
  const isNonUsd = !!currency && currency.toUpperCase() !== 'USD'
  const canChangeCard = enableBalanceCreditCards || isNonUsd
  return {
    isNonUsd,
    isFeeCardOnly: isSellerCollects && enableBalanceCreditCards && !isNonUsd,
    canChangeCard,
    canAddCard: canChangeCard && !isAccountCardBlocked,
  }
}
